'use strict';

var chunkFDFFBB2X_js = require('../chunk-FDFFBB2X.js');
var chunkLF7FCT4H_js = require('../chunk-LF7FCT4H.js');
require('../chunk-HZJFQ3ZG.js');
require('../chunk-CQFCOHVG.js');
require('../chunk-5GS27WKA.js');
var chunkHCZW57S2_js = require('../chunk-HCZW57S2.js');
require('../chunk-3A5DQBXA.js');
require('../chunk-C7C34JBA.js');
require('../chunk-WVST6R4U.js');
require('../chunk-33IWXYMJ.js');
require('../chunk-3WOKHVFK.js');
require('../chunk-SNEGV6DE.js');
require('../chunk-HPRUU6IH.js');
require('../chunk-TI4S3S4J.js');
require('../chunk-7GTRMEIW.js');
require('../chunk-VNK76C2V.js');
require('../chunk-H6SGADBR.js');
require('../chunk-OXXOHGTT.js');
require('../chunk-HUKGHOBJ.js');
require('../chunk-S7FZ7BAB.js');
require('../chunk-M632V57T.js');
var r = require('react');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var r__default = /*#__PURE__*/_interopDefault(r);

var s=({isMobile:i,isRevamped:p,...o})=>p?r__default.default.createElement(chunkLF7FCT4H_js.a,{...o}):i?r__default.default.createElement(chunkHCZW57S2_js.a,{...o}):r__default.default.createElement(chunkFDFFBB2X_js.a,{...o});

exports.Footer = s;
